import React from 'react';
import {observer} from 'mobx-react';

import {useStores} from '../../stores/use-stores';

import FeedList from './components/FeedList';

const FeedListScreen = observer(() => {
  const {shopSelectionStore} = useStores();

  // temporary values for loading temporary content from the default store if
  // an store has not been selected
  let canStorePickup = true;
  let canStoreDeliver = true;
  let isStoreLoading = false;

  if (shopSelectionStore.selectedStore) {
    canStorePickup = shopSelectionStore.canPickup;
    canStoreDeliver = shopSelectionStore.canDeliver;
    isStoreLoading = shopSelectionStore.storeLoading;
  }

  return (
    <FeedList
      canStoreDeliver={canStoreDeliver}
      canStorePickup={canStorePickup}
      isStoreLoading={isStoreLoading}
    />
  );
});

export default FeedListScreen;
